import React, { Component } from 'react'
import ReactQuill from 'react-quill' // ES6

import PropTypes from 'prop-types'

import { isCurrentLanguageRTL } from '../../i18n'; 

export default class TextEditor extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string,
    theme: PropTypes.string,
    value: PropTypes.string
  }

  static defaultProps = {
    theme: 'snow'
  }

  render() {
    const { id, theme, onChange, placeholder, defaultValue, value } = this.props

    const modules = {
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link', 'image'],
        ['clean']
      ]
    }

    const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image']

    let quillDirectionStyle = {
          direction: isCurrentLanguageRTL() ? 'rtl' : 'ltr'
    };

    return (
      <ReactQuill
              id={id}
              theme={theme}
              modules={modules}
              formats={formats}
              defaultValue={defaultValue}
              placeholder={placeholder}
              onChange={(content, delta, source, editor) => {
                onChange(content, delta, source, editor)
              }}
              style={quillDirectionStyle}
              value={value}
            />
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/TextEditor.jsx